// start:ng42.barrel
import './transport-route-updates.component';
// end:ng42.barrel

